export const preferredServiceProviderLabel = 'preferred service provider';
export const serviceProviderLabel = 'service provider';
export const noPreferredPhotographersString = 'No preferred service provider assigned yet...';
export const noTechString = 'No service provider assigned yet...';
export const editTechString = 'Edit service provider';
export const editPreferredTechString = 'Edit preferred service provider';
export const editTechHover = 'edit service provider';
export const editPreferredTechHover = 'edit preferred service provider';
export const editIconAlt = 'edit';
